// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file aplicaciones.proto (package sextante.aplicaciones.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file aplicaciones.proto.
 */
export const file_aplicaciones: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Producto aplicado y su dosis.
 *
 * @generated from message sextante.aplicaciones.v1.AplicacionDetalleItem
 */
export type AplicacionDetalleItem = Message<"sextante.aplicaciones.v1.AplicacionDetalleItem"> & {
  /**
   * @generated from field: string producto_id = 1;
   */
  productoId: string;

  /**
   * @generated from field: string producto_descripcion = 2;
   */
  productoDescripcion: string;

  /**
   * La unidad depende del metodo: por hectarea en dron, por recipiente en los manuales. Son excluyentes
   * -una aplicacion tiene un solo metodo-, asi que es un campo y no dos: con dos, uno estaria siempre en
   * cero y toda lectura tendria que saber cual mirar. Se llamaba dosis_hectarea hasta el 2026-10-15.
   *
   * @generated from field: double dosis = 3;
   */
  dosis: number;

  /**
   * @generated from field: string unidad_medida = 4;
   */
  unidadMedida: string;
};

/**
 * Describes the message sextante.aplicaciones.v1.AplicacionDetalleItem.
 * Use `create(AplicacionDetalleItemSchema)` to create a new message.
 */
export const AplicacionDetalleItemSchema: GenMessage<AplicacionDetalleItem> = /*@__PURE__*/
  messageDesc(file_aplicaciones, 0);

/**
 * Un lote de una aplicacion manual, con cuanto se le aplico. Las aplicaciones por dron no traen ninguno:
 * por donde paso el vuelo ya lo dice su trayectoria.
 *
 * @generated from message sextante.aplicaciones.v1.AplicacionLoteItem
 */
export type AplicacionLoteItem = Message<"sextante.aplicaciones.v1.AplicacionLoteItem"> & {
  /**
   * @generated from field: string lote_id = 1;
   */
  loteId: string;

  /**
   * Denormalizado como producto_descripcion en el detalle: si el lote se da de baja, el registro tiene que
   * seguir diciendo donde se aplico.
   *
   * @generated from field: string lote_nombre = 2;
   */
  loteNombre: string;

  /**
   * Recipientes aplicados (acepta decimales: media caneca es una cantidad normal). Ausente en drench.
   *
   * @generated from field: optional double cantidad = 3;
   */
  cantidad?: number | undefined;

  /**
   * Plantas tratadas. Solo en drench, donde la cantidad se anota en plantas y no en recipientes.
   *
   * @generated from field: optional int32 plantas = 4;
   */
  plantas?: number | undefined;
};

/**
 * Describes the message sextante.aplicaciones.v1.AplicacionLoteItem.
 * Use `create(AplicacionLoteItemSchema)` to create a new message.
 */
export const AplicacionLoteItemSchema: GenMessage<AplicacionLoteItem> = /*@__PURE__*/
  messageDesc(file_aplicaciones, 1);

/**
 * Campos de AplicacionResponse SIN uso real en Cliente (auditado en toda la app, no solo en los
 * consumidores directos del servicio): NO van cliente_id, cultivo_id ni cultivo_tratamiento_id -el
 * cliente solo muestra los nombres ya resueltos (cultivo_nombre/cultivo_tratamiento_nombre), nunca
 * vuelve a leer el id del cultivo desde una aplicacion ya guardada-. descarga_ha tampoco: es
 * total_amount / task_area, calculable en el cliente sin mandarlo aparte.
 * 
 * vuelo (trayectoria del vuelo) viaja como GeoJSON (string), NO WKB: mismo motivo que
 * area_geografica_polygon en terceros_lote.proto. En las aplicaciones manuales viaja <b>vacio</b>: no hay
 * dron, no hay trayectoria -el mapa pinta los lotes aplicados en su lugar-.
 * fecha_aplicacion es DateOnly (fecha de calendario, no un instante): viaja como string "yyyy-MM-dd",
 * no epoch ms.
 *
 * @generated from message sextante.aplicaciones.v1.AplicacionItem
 */
export type AplicacionItem = Message<"sextante.aplicaciones.v1.AplicacionItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja: la app lo quita de su base local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * Ultimo cambio del registro, en Unix ms.
   *
   * @generated from field: int64 ultima_actualizacion = 3;
   */
  ultimaActualizacion: bigint;

  /**
   * @generated from field: string finca_id = 4;
   */
  fincaId: string;

  /**
   * @generated from field: optional string cultivo_nombre = 5;
   */
  cultivoNombre?: string | undefined;

  /**
   * @generated from field: optional string cultivo_tratamiento_nombre = 6;
   */
  cultivoTratamientoNombre?: string | undefined;

  /**
   * @generated from field: string fecha_aplicacion = 7;
   */
  fechaAplicacion: string;

  /**
   * GeoJSON MultiLineString; vacio en los metodos manuales
   *
   * @generated from field: string vuelo = 8;
   */
  vuelo: string;

  /**
   * Area aplicada en hectareas: segun el KML en dron, suma del area de los lotes en manual.
   *
   * @generated from field: double task_area = 9;
   */
  taskArea: number;

  /**
   * Volumen total aplicado en litros: segun el KML en dron, suma de la mezcla de los lotes en manual.
   *
   * @generated from field: double total_amount = 10;
   */
  totalAmount: number;

  /**
   * @generated from field: repeated sextante.aplicaciones.v1.AplicacionDetalleItem detalles = 11;
   */
  detalles: AplicacionDetalleItem[];

  /**
   * Con que se aplico: "dron" | "estacionaria" | "espalda" | "tractor" | "drench".
   *
   * @generated from field: string metodo = 12;
   */
  metodo: string;

  /**
   * --- Solo en los metodos manuales (ausentes en dron) ---
   * Recipiente con el que se midio. Es referencia para mostrar su nombre; las cuentas usan
   * volumen_recipiente_litros, que quedo congelado al guardar.
   *
   * @generated from field: optional string recipiente_id = 13;
   */
  recipienteId?: string | undefined;

  /**
   * @generated from field: optional string recipiente_nombre = 14;
   */
  recipienteNombre?: string | undefined;

  /**
   * Litros del recipiente congelados al guardar: corregir la caneca de 200 a 180 L no puede cambiar solo
   * el volumen que ya quedo registrado en las aplicaciones anteriores.
   *
   * @generated from field: optional double volumen_recipiente_litros = 15;
   */
  volumenRecipienteLitros?: number | undefined;

  /**
   * Mililitros de mezcla por planta (solo drench): el factor que convierte plantas en litros.
   *
   * @generated from field: optional double mezcla_por_planta_ml = 16;
   */
  mezclaPorPlantaMl?: number | undefined;

  /**
   * Capacidad de la bomba de espalda, en litros (solo espalda). Informativo.
   *
   * @generated from field: optional double capacidad_bomba_litros = 17;
   */
  capacidadBombaLitros?: number | undefined;

  /**
   * Equipo con el que se aplico (estacionaria, tractor), texto libre: no hay catalogo de equipos.
   *
   * @generated from field: optional string equipo = 18;
   */
  equipo?: string | undefined;

  /**
   * Quien aplico: persona o cuadrilla. Texto libre, no un usuario del sistema.
   *
   * @generated from field: optional string responsable = 19;
   */
  responsable?: string | undefined;

  /**
   * @generated from field: repeated sextante.aplicaciones.v1.AplicacionLoteItem lotes = 20;
   */
  lotes: AplicacionLoteItem[];
};

/**
 * Describes the message sextante.aplicaciones.v1.AplicacionItem.
 * Use `create(AplicacionItemSchema)` to create a new message.
 */
export const AplicacionItemSchema: GenMessage<AplicacionItem> = /*@__PURE__*/
  messageDesc(file_aplicaciones, 2);

/**
 * Pedido del listado de aplicaciones de una finca.
 *
 * @generated from message sextante.aplicaciones.v1.ListAplicacionesByFincaIdRequest
 */
export type ListAplicacionesByFincaIdRequest = Message<"sextante.aplicaciones.v1.ListAplicacionesByFincaIdRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 2;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.aplicaciones.v1.ListAplicacionesByFincaIdRequest.
 * Use `create(ListAplicacionesByFincaIdRequestSchema)` to create a new message.
 */
export const ListAplicacionesByFincaIdRequestSchema: GenMessage<ListAplicacionesByFincaIdRequest> = /*@__PURE__*/
  messageDesc(file_aplicaciones, 3);

/**
 * Aplicaciones que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.aplicaciones.v1.ListAplicacionesByFincaIdResponse
 */
export type ListAplicacionesByFincaIdResponse = Message<"sextante.aplicaciones.v1.ListAplicacionesByFincaIdResponse"> & {
  /**
   * @generated from field: repeated sextante.aplicaciones.v1.AplicacionItem items = 1;
   */
  items: AplicacionItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.aplicaciones.v1.ListAplicacionesByFincaIdResponse.
 * Use `create(ListAplicacionesByFincaIdResponseSchema)` to create a new message.
 */
export const ListAplicacionesByFincaIdResponseSchema: GenMessage<ListAplicacionesByFincaIdResponse> = /*@__PURE__*/
  messageDesc(file_aplicaciones, 4);

/**
 * Producto a aplicar y su dosis (por hectarea en dron, por recipiente en los manuales).
 *
 * @generated from message sextante.aplicaciones.v1.AplicacionDetalleRequestItem
 */
export type AplicacionDetalleRequestItem = Message<"sextante.aplicaciones.v1.AplicacionDetalleRequestItem"> & {
  /**
   * @generated from field: string producto_id = 1;
   */
  productoId: string;

  /**
   * @generated from field: double dosis = 2;
   */
  dosis: number;
};

/**
 * Describes the message sextante.aplicaciones.v1.AplicacionDetalleRequestItem.
 * Use `create(AplicacionDetalleRequestItemSchema)` to create a new message.
 */
export const AplicacionDetalleRequestItemSchema: GenMessage<AplicacionDetalleRequestItem> = /*@__PURE__*/
  messageDesc(file_aplicaciones, 5);

/**
 * Lote a aplicar y cuanto. Segun el metodo tiene que venir cantidad (recipientes) o plantas (drench), no
 * las dos ni ninguna; el servidor lo valida.
 *
 * @generated from message sextante.aplicaciones.v1.AplicacionLoteRequestItem
 */
export type AplicacionLoteRequestItem = Message<"sextante.aplicaciones.v1.AplicacionLoteRequestItem"> & {
  /**
   * @generated from field: string lote_id = 1;
   */
  loteId: string;

  /**
   * @generated from field: optional double cantidad = 2;
   */
  cantidad?: number | undefined;

  /**
   * @generated from field: optional int32 plantas = 3;
   */
  plantas?: number | undefined;
};

/**
 * Describes the message sextante.aplicaciones.v1.AplicacionLoteRequestItem.
 * Use `create(AplicacionLoteRequestItemSchema)` to create a new message.
 */
export const AplicacionLoteRequestItemSchema: GenMessage<AplicacionLoteRequestItem> = /*@__PURE__*/
  messageDesc(file_aplicaciones, 6);

/**
 * Omitir id crea, incluirlo actualiza (mismo rpc para ambos casos). Que campos son obligatorios depende
 * del metodo, y lo valida el servidor:
 *  - dron: vuelo_url al crear (al actualizar, si falta conserva el vuelo actual). Ignora todo lo manual.
 *  - manuales: recipiente_id, responsable y al menos un lote; mezcla_por_planta_ml ademas en drench. Sin
 *    vuelo_url.
 *
 * @generated from message sextante.aplicaciones.v1.GuardarAplicacionRequest
 */
export type GuardarAplicacionRequest = Message<"sextante.aplicaciones.v1.GuardarAplicacionRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string finca_id = 2;
   */
  fincaId: string;

  /**
   * @generated from field: string cultivo_id = 3;
   */
  cultivoId: string;

  /**
   * @generated from field: string cultivo_tratamiento_id = 4;
   */
  cultivoTratamientoId: string;

  /**
   * @generated from field: string fecha_aplicacion = 5;
   */
  fechaAplicacion: string;

  /**
   * URL del archivo de vuelo ya subido a Storage. Obligatoria al crear una aplicacion por dron.
   *
   * @generated from field: optional string vuelo_url = 6;
   */
  vueloUrl?: string | undefined;

  /**
   * @generated from field: repeated sextante.aplicaciones.v1.AplicacionDetalleRequestItem detalles = 7;
   */
  detalles: AplicacionDetalleRequestItem[];

  /**
   * Con que se aplico: "dron" | "estacionaria" | "espalda" | "tractor" | "drench". Vacio = "dron", para que
   * un cliente viejo que no lo manda siga guardando como antes.
   *
   * @generated from field: string metodo = 8;
   */
  metodo: string;

  /**
   * @generated from field: optional string recipiente_id = 9;
   */
  recipienteId?: string | undefined;

  /**
   * @generated from field: optional double mezcla_por_planta_ml = 10;
   */
  mezclaPorPlantaMl?: number | undefined;

  /**
   * @generated from field: optional double capacidad_bomba_litros = 11;
   */
  capacidadBombaLitros?: number | undefined;

  /**
   * @generated from field: optional string equipo = 12;
   */
  equipo?: string | undefined;

  /**
   * @generated from field: optional string responsable = 13;
   */
  responsable?: string | undefined;

  /**
   * @generated from field: repeated sextante.aplicaciones.v1.AplicacionLoteRequestItem lotes = 14;
   */
  lotes: AplicacionLoteRequestItem[];
};

/**
 * Describes the message sextante.aplicaciones.v1.GuardarAplicacionRequest.
 * Use `create(GuardarAplicacionRequestSchema)` to create a new message.
 */
export const GuardarAplicacionRequestSchema: GenMessage<GuardarAplicacionRequest> = /*@__PURE__*/
  messageDesc(file_aplicaciones, 7);

/**
 * Aplicacion a eliminar.
 *
 * @generated from message sextante.aplicaciones.v1.EliminarAplicacionRequest
 */
export type EliminarAplicacionRequest = Message<"sextante.aplicaciones.v1.EliminarAplicacionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.aplicaciones.v1.EliminarAplicacionRequest.
 * Use `create(EliminarAplicacionRequestSchema)` to create a new message.
 */
export const EliminarAplicacionRequestSchema: GenMessage<EliminarAplicacionRequest> = /*@__PURE__*/
  messageDesc(file_aplicaciones, 8);

/**
 * Sin datos: que el rpc no falle ya indica que se elimino.
 *
 * @generated from message sextante.aplicaciones.v1.EliminarAplicacionResponse
 */
export type EliminarAplicacionResponse = Message<"sextante.aplicaciones.v1.EliminarAplicacionResponse"> & {
};

/**
 * Describes the message sextante.aplicaciones.v1.EliminarAplicacionResponse.
 * Use `create(EliminarAplicacionResponseSchema)` to create a new message.
 */
export const EliminarAplicacionResponseSchema: GenMessage<EliminarAplicacionResponse> = /*@__PURE__*/
  messageDesc(file_aplicaciones, 9);

/**
 * Recipiente con su equivalencia en litros. Siempre es de un cliente.
 *
 * @generated from message sextante.aplicaciones.v1.AplicacionRecipienteItem
 */
export type AplicacionRecipienteItem = Message<"sextante.aplicaciones.v1.AplicacionRecipienteItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja: la app lo quita de su base local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * Ultimo cambio del registro, en Unix ms.
   *
   * @generated from field: int64 ultima_actualizacion = 3;
   */
  ultimaActualizacion: bigint;

  /**
   * @generated from field: string cliente_id = 4;
   */
  clienteId: string;

  /**
   * @generated from field: string nombre = 5;
   */
  nombre: string;

  /**
   * Litros de mezcla que le caben: el factor que convierte "3 canecas" en litros.
   *
   * @generated from field: double litros = 6;
   */
  litros: number;
};

/**
 * Describes the message sextante.aplicaciones.v1.AplicacionRecipienteItem.
 * Use `create(AplicacionRecipienteItemSchema)` to create a new message.
 */
export const AplicacionRecipienteItemSchema: GenMessage<AplicacionRecipienteItem> = /*@__PURE__*/
  messageDesc(file_aplicaciones, 10);

/**
 * Pedido de los recipientes de un cliente.
 *
 * @generated from message sextante.aplicaciones.v1.ListAplicacionRecipientesByClienteIdRequest
 */
export type ListAplicacionRecipientesByClienteIdRequest = Message<"sextante.aplicaciones.v1.ListAplicacionRecipientesByClienteIdRequest"> & {
  /**
   * @generated from field: string cliente_id = 1;
   */
  clienteId: string;

  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 2;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.aplicaciones.v1.ListAplicacionRecipientesByClienteIdRequest.
 * Use `create(ListAplicacionRecipientesByClienteIdRequestSchema)` to create a new message.
 */
export const ListAplicacionRecipientesByClienteIdRequestSchema: GenMessage<ListAplicacionRecipientesByClienteIdRequest> = /*@__PURE__*/
  messageDesc(file_aplicaciones, 11);

/**
 * Recipientes que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.aplicaciones.v1.ListAplicacionRecipientesByClienteIdResponse
 */
export type ListAplicacionRecipientesByClienteIdResponse = Message<"sextante.aplicaciones.v1.ListAplicacionRecipientesByClienteIdResponse"> & {
  /**
   * @generated from field: repeated sextante.aplicaciones.v1.AplicacionRecipienteItem items = 1;
   */
  items: AplicacionRecipienteItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.aplicaciones.v1.ListAplicacionRecipientesByClienteIdResponse.
 * Use `create(ListAplicacionRecipientesByClienteIdResponseSchema)` to create a new message.
 */
export const ListAplicacionRecipientesByClienteIdResponseSchema: GenMessage<ListAplicacionRecipientesByClienteIdResponse> = /*@__PURE__*/
  messageDesc(file_aplicaciones, 12);

/**
 * Datos del recipiente a crear o editar. Omitir id crea, incluirlo actualiza.
 *
 * @generated from message sextante.aplicaciones.v1.GuardarAplicacionRecipienteRequest
 */
export type GuardarAplicacionRecipienteRequest = Message<"sextante.aplicaciones.v1.GuardarAplicacionRecipienteRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string cliente_id = 2;
   */
  clienteId: string;

  /**
   * @generated from field: string nombre = 3;
   */
  nombre: string;

  /**
   * @generated from field: double litros = 4;
   */
  litros: number;
};

/**
 * Describes the message sextante.aplicaciones.v1.GuardarAplicacionRecipienteRequest.
 * Use `create(GuardarAplicacionRecipienteRequestSchema)` to create a new message.
 */
export const GuardarAplicacionRecipienteRequestSchema: GenMessage<GuardarAplicacionRecipienteRequest> = /*@__PURE__*/
  messageDesc(file_aplicaciones, 13);

/**
 * Recipiente a eliminar.
 *
 * @generated from message sextante.aplicaciones.v1.EliminarAplicacionRecipienteRequest
 */
export type EliminarAplicacionRecipienteRequest = Message<"sextante.aplicaciones.v1.EliminarAplicacionRecipienteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.aplicaciones.v1.EliminarAplicacionRecipienteRequest.
 * Use `create(EliminarAplicacionRecipienteRequestSchema)` to create a new message.
 */
export const EliminarAplicacionRecipienteRequestSchema: GenMessage<EliminarAplicacionRecipienteRequest> = /*@__PURE__*/
  messageDesc(file_aplicaciones, 14);

/**
 * Sin datos: que el rpc no falle ya indica que se elimino.
 *
 * @generated from message sextante.aplicaciones.v1.EliminarAplicacionRecipienteResponse
 */
export type EliminarAplicacionRecipienteResponse = Message<"sextante.aplicaciones.v1.EliminarAplicacionRecipienteResponse"> & {
};

/**
 * Describes the message sextante.aplicaciones.v1.EliminarAplicacionRecipienteResponse.
 * Use `create(EliminarAplicacionRecipienteResponseSchema)` to create a new message.
 */
export const EliminarAplicacionRecipienteResponseSchema: GenMessage<EliminarAplicacionRecipienteResponse> = /*@__PURE__*/
  messageDesc(file_aplicaciones, 15);

/**
 * Aplicaciones (aspersiones) sobre los cultivos de una finca, de la SPA Cliente: listado por finca con
 * delta, guardado y baja. Logica propia del servicio gRPC, sin la capa vieja de servicios. Requiere sesion
 * de la app Cliente.
 * 
 * El metodo parte la aplicacion en dos formas de medirla:
 *  - dron: el servidor deriva trayectoria, area y volumen del archivo de vuelo (zip con KML) que la app
 *    sube a Storage, y la dosis del producto es por hectarea.
 *  - manuales (estacionaria, espalda, tractor, drench): no hay vuelo. La app manda cuantos recipientes
 *    -o cuantas plantas, en drench- se aplicaron en cada lote, el servidor deriva de ahi el area (suma del
 *    area de los lotes) y el volumen (mezcla de cada lote), y la dosis del producto es por recipiente.
 * 
 * Nombres de mensaje con prefijo "Aplicacion", no genericos: csharp_namespace es el mismo "Api.Grpc"
 * en todos los .proto de este proyecto (ver terceros_lote.proto para el gotcha real que motivo esta
 * regla) — revisar que un nombre no exista ya en otro .proto antes de usarlo
 * (grep -rn "^message " Api/Protos/*.proto).
 * 
 * Pertenencia (2026-09-30): solo trabaja con datos de fincas del cliente de la sesion. Una finca, lote o
 * registro de otro cliente responde NotFound, igual que uno inexistente.
 *
 * @generated from service sextante.aplicaciones.v1.AplicacionService
 */
export const AplicacionService: GenService<{
  /**
   * Aplicaciones de una finca, por delta: solo las que cambiaron desde ultima_sincronizacion.
   *
   * @generated from rpc sextante.aplicaciones.v1.AplicacionService.ListByFincaId
   */
  listByFincaId: {
    methodKind: "unary";
    input: typeof ListAplicacionesByFincaIdRequestSchema;
    output: typeof ListAplicacionesByFincaIdResponseSchema;
  },
  /**
   * Crea la aplicacion si no viene id, o la actualiza si viene. Devuelve la aplicacion guardada, con los
   * datos del vuelo ya calculados.
   *
   * @generated from rpc sextante.aplicaciones.v1.AplicacionService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarAplicacionRequestSchema;
    output: typeof AplicacionItemSchema;
  },
  /**
   * Elimina una aplicacion. Si no existe no hace nada.
   *
   * @generated from rpc sextante.aplicaciones.v1.AplicacionService.Eliminar
   */
  eliminar: {
    methodKind: "unary";
    input: typeof EliminarAplicacionRequestSchema;
    output: typeof EliminarAplicacionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_aplicaciones, 0);

/**
 * Recipientes con los que se mide una aplicacion manual: la caneca o el tanque con el que se prepara y
 * se reparte la mezcla, con su equivalencia en litros. Una aplicacion que no es por dron no se mide en
 * hectareas sino en recipientes llenos ("3 canecas en el lote 4"), y para pasar de eso a litros hay que
 * saber cuanto le cabe a una.
 * 
 * Todo recipiente es de un cliente: el suyo lo ve, lo edita y lo borra solo el. Para que la lista no
 * arranque vacia -sin ningun recipiente no se puede registrar una aplicacion manual-, la primera vez que
 * un cliente la pide se le siembran sus propias copias de los dos tamanos estandar.
 * 
 * El 2026-10-14 esos dos eran globales (cliente_id nulo) y de solo lectura, como las tareas globales de
 * configuracion_tarea.proto. Se descarto al dia siguiente: son justo los que cada finca necesita ajustar
 * y no se podia tocar ninguno.
 * 
 * Pertenencia (2026-09-30): el cliente_id del pedido tiene que ser el de la sesion, y solo se tocan
 * registros de ese cliente. Otro cliente responde NotFound, igual que uno inexistente.
 *
 * @generated from service sextante.aplicaciones.v1.AplicacionRecipienteService
 */
export const AplicacionRecipienteService: GenService<{
  /**
   * Recipientes del cliente, por delta. Si nunca tuvo ninguno, primero se le siembran los dos estandar.
   *
   * @generated from rpc sextante.aplicaciones.v1.AplicacionRecipienteService.ListByClienteId
   */
  listByClienteId: {
    methodKind: "unary";
    input: typeof ListAplicacionRecipientesByClienteIdRequestSchema;
    output: typeof ListAplicacionRecipientesByClienteIdResponseSchema;
  },
  /**
   * Crea el recipiente si no viene id, o edita uno del cliente si viene. El nombre no se puede repetir entre
   * los recipientes activos del cliente, y los litros tienen que ser mayores a cero.
   *
   * @generated from rpc sextante.aplicaciones.v1.AplicacionRecipienteService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarAplicacionRecipienteRequestSchema;
    output: typeof AplicacionRecipienteItemSchema;
  },
  /**
   * Elimina un recipiente del cliente. Si no existe o es de otro cliente no hace nada.
   *
   * @generated from rpc sextante.aplicaciones.v1.AplicacionRecipienteService.Eliminar
   */
  eliminar: {
    methodKind: "unary";
    input: typeof EliminarAplicacionRecipienteRequestSchema;
    output: typeof EliminarAplicacionRecipienteResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_aplicaciones, 1);

